// getAllCompany,getAllSalesReps,
import {getSalesRepPhysician, salesRep, exportAutoCaseLog} from '../../../service/service'

export default {
    name: 'automatic-viewing',
    data: function () {
        return {
            data2: [],
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            dateViewed: '',
            keywordSearch: '',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    width: 150,
                    key: 'CaseId',tooltip:true
                }, {
                    title: this.$t('physician'),
                    key: 'Physician',tooltip:true
                }, {
                    title: this.$t('specialty'),
                    key: 'Specialty',tooltip:true
                },
                {
                    title: this.$t('patient name'),
                    key: 'PatientName',tooltip:true
                },
                {
                    title: this.$t('patient id'),
                    key: 'PatientId',tooltip:true
                },
                {
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'Hospital',tooltip:true
                },
                {
                    title: this.$t('date viewed'),
                    key: 'DateViews',tooltip:true
                },
                {
                    title: this.$t('date of surgery'),
                    key: 'DateOfSurgery',tooltip:true
                },
                {
                    title: this.$t('add note'),
                    slot: 'action',tooltip:true
                },
                {
                    title: this.$t('more info'),
                    slot: 'more'
                }
            ],
            data1: [],
            modal: false,
            modal1: false,
            txtComment: '',
            showDetailModal: false,
            commentList: [],
            pagesize: 20,
            pageTo: "1",
            page: 1,
            token: '',
            arrTree: [],
            tempTree:[],
            searchMark: false,
            timeoutId: '',
            tid: 0,
            tname: '',
            dataInfo: null,
            isSelectTree: false,
            chooseRow: [{'caseId': 'caseId'}]
        }
    },
    methods: {
        toCsv() {
            exportAutoCaseLog({
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        // pageInput(){
        //     if(this.page){
        //         this.page = parseInt(this.page)
        //     }
        // },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        reloadView() {
            let obj = {
                "userId": this.token,
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            }
            salesRep.automatic.getAutomaticData(obj).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    console.log(data)
                    this.data1 = data.list
                    // console.log(JSON.parse(data.list))
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                    this.total = data.total
                }
            })
        },
        changePatientName() {
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        selectTree(e) {
            this.page = 1
            this.pageTo = 1
            let arr = []
            if (e.length > 0) {
                e.forEach(i => {
                    if (!i.children) {
                        // console.log(i)
                        let obj = {
                            physicianID: i.id
                        }
                        arr.push(obj)
                    }
                });
            } else {
                this.physiciansList.forEach(i => {
                    let obj2 = {
                        physicianID: i.DocId
                    }
                    arr.push(obj2)
                })
                let otherobj = {
                    physicianID: "other"
                }
                arr.push(otherobj);
            }
            this.arrTree = arr
            this.reloadView()
        },
        addComment1() {
            this.modal1 = true
        },
        changePageSize(size) {
            this.page = 1
            this.pagesize = size
            this.pageTo = 1
            this.reloadView()
        },
        showDetail(row) {
            this.tid = row.CaseId
            console.log(row)
            this.tname = row.name
            let p = {
                userId: this.token,
                id: this.tid
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.automatic.getAutomaticInfo(p).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    this.dataInfo = data
                    console.log(data)
                    salesRep.automatic.getAutomaticComment(p).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                        } else {
                            this.$Message.warning(this.$t('fail'))
                        }
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        ok1() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = localStorage.getItem('userName')
            let obj = {
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }
            console.log(obj)
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.automatic.addAutomaticComment(obj).then(res => {
                console.log(res)
                let code = parseInt(res.code)
                if (!code) {
                    this.modal1 = false
                    this.txtComment = ''
                    this.tname = ''
                    let p = {
                        userId: this.token,
                        id: this.tid
                    }
                    salesRep.automatic.getAutomaticComment(p).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide();
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                        }
                    })
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel1() {
            this.tid = 0
            this.txtComment = ''
            this.tname = ''
            this.modal1 = false
        },
        ok() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = localStorage.getItem('userName')
            let obj = {
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.automatic.addAutomaticComment(obj).then(res => {
                console.log(res)
                this.$Spin.hide();
                let code = parseInt(res.code)
                if (!code) {
                    this.modal = false
                    this.tid = 0
                    this.txtComment = ''
                    this.tname = ''
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel() {
            this.tid = 0
            this.txtComment = ''
            this.tname = ''
            this.modal = false
        },
        addComment(row, index) {
            console.log(row)
            console.log(index)
            this.tid = row.id
            this.tname = row.name
            this.modal = true
        },
        showDate() {
            // console.log(this.dateOfSurgery)
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        dateChange1(e) {
            this.page = 1
            this.pageTo = 1
            this.dateViewed = e
            this.reloadView()
        },
        dateChange(e) {
            this.page = 1
            this.pageTo = 1
            this.dateOfSurgery = e
            this.reloadView()
        }
    },
    created() {

    },
    mounted() {
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        // console.log(token)
        // eslint-disable-next-line no-irregular-whitespace
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        let arr = [{
            title: 'All Physicians',
            id: 0,
            children: [],
            expand: true
        }]
        let arr2 = []
        getSalesRepPhysician({UserUID: this.token}).then(res => {
            console.log(res)
            this.physiciansList = res.Physician
            res.Physician.forEach(i => {
                let obj = {
                    title: i.DocName,
                    id: i.DocId,
                    expand: true
                }
                let obj2 = {
                    physicianID: i.DocId
                }
                arr[0].children.push(obj)
                arr2.push(obj2)
            })
            let otherobj = {
                physicianID: "other"
            }
            arr2.push(otherobj);
            let otherObj = {
                title: 'Other',
                id: 'other',
                expand: true
            }

            arr[0].children.push(otherObj)
            this.data2 = arr
            this.arrTree = arr2
            // this.isSelectTree = true
            this.reloadView()
        })
        // getAllSalesReps({UserUID: this.token}).then(res=>{
        //   res.SalesReps.forEach(i=>{
        //     let obj = {
        //       title: i.SalesName,
        //       expand: true,
        //       children: []
        //     }

        //     arr.push(obj)
        //     this.data2 = arr
        //   })
        // })
    }
}
